var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-search",
    clipPath: "url(#clip0_2126_5269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5851 12.7902L10.2276 9.43268C11.1425 8.31364 11.5924 6.88573 11.4841 5.4443C11.3758 4.00288 10.7176 2.65823 9.64571 1.68847C8.57379 0.718714 7.17015 0.198054 5.72511 0.234184C4.28008 0.270314 2.90421 0.860471 1.8821 1.88258C0.859983 2.9047 0.269826 4.28057 0.233696 5.7256C0.197565 7.17063 0.718226 8.57428 1.68798 9.64619C2.65774 10.7181 4.00239 11.3763 5.44382 11.4846C6.88524 11.5929 8.31315 11.143 9.43219 10.2281L12.7898 13.5856C12.8958 13.6881 13.0379 13.7448 13.1854 13.7435C13.3329 13.7422 13.474 13.6831 13.5783 13.5788C13.6826 13.4745 13.7417 13.3334 13.743 13.1859C13.7443 13.0384 13.6876 12.8963 13.5851 12.7902ZM5.87494 10.3754C4.98492 10.3754 4.11489 10.1115 3.37487 9.61704C2.63485 9.12257 2.05807 8.41977 1.71748 7.5975C1.37689 6.77523 1.28777 5.87043 1.4614 4.99752C1.63504 4.12461 2.06362 3.32278 2.69296 2.69345C3.32229 2.06411 4.12412 1.63553 4.99703 1.46189C5.86995 1.28826 6.77475 1.37737 7.59701 1.71797C8.41928 2.05856 9.12209 2.63534 9.61655 3.37536C10.111 4.11538 10.3749 4.98541 10.3749 5.87543C10.3736 7.06849 9.89906 8.2123 9.05544 9.05593C8.21182 9.89955 7.068 10.3741 5.87494 10.3754Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2126_5269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(0.25 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrSearch);
export default __webpack_public_path__ + "static/media/fi-rr-search.a9945103.svg";
export { ForwardRef as ReactComponent };